export default __webpack_public_path__ + "static/media/cifrao.425e5b25.svg";